// @flow

import React, { Component } from 'react';
import { createRefetchContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router-dom';
// material-ui

import FlatButton from 'material-ui/FlatButton';
import { styles } from '../../lib/styles';
import ContentAdd from 'material-ui/svg-icons/content/add';
import ConfigurableBlockListItem from './ConfigurableBlockListItem';
import { DataGrid } from '../ui/data-grid/data-grid';

type Props = {
	history: Object,
	location: Object,
	match: Object,
	relay: Object,
	router: Object,
	viewer: Object,
};

type State = {
	currentQuery: ?string,
	pageCursor: number,
	searchText: ?string,
	section: string,
	states: Array<?string>,
	totalPages: number,
};

class ConfigurableBlockList extends Component<Props, State> {
	render() {
		const items = this.props.viewer.blocks.edges || [];
		return (
			<section className="wrapper">
				<div className="paper-wrapper" style={{ width: '100%' }}>
					<section className="paper paper_main">
						<header className="paper-header" style={{ alignItems: 'center', justifyContent: 'space-between' }}>
							<h3 className="articles-header--title">Конфигурируемые блоки</h3>
							<div>
								<FlatButton
									label="Добавить"
									style={{ ...styles.headerButton, marginLeft: 8 }}
									primary
									icon={<ContentAdd />}
									onClick={() => this.props.history.push(`/configurable-blocks/new`)}
									labelStyle={{ paddingLeft: 6, paddingRight: 18 }}
								/>
							</div>
						</header>
						<DataGrid columns={['Тип', 'Системное имя', 'Активный']} items={items}>
							{items.map(({ node }) => (
								<ConfigurableBlockListItem key={node.id} block={node} router={this.props.router} viewer={this.props.viewer} />
							))}
						</DataGrid>
					</section>
				</div>
			</section>
		);
	}
}

export default withRouter(
	createRefetchContainer(
		ConfigurableBlockList,
		graphql`
			fragment ConfigurableBlockList_viewer on Viewer {
				blocks: configurableBlocks {
					edges {
						node {
							id
							...ConfigurableBlockListItem_block
						}
					}
				}
			}
		`,
		graphql`
			query ConfigurableBlockList_Refetch_Query {
				viewer {
					...ConfigurableBlockList_viewer
				}
			}
		`,
	),
);



// WEBPACK FOOTER //
// src/components/configurable-blocks/ConfigurableBlockList.js